/* eslint-disable react/prop-types */
import React, { useCallback, useRef, useState, useEffect } from 'react';
import ReactTags from 'react-tag-autocomplete';
import remove from 'lodash/remove';
import findIndex from 'lodash/findIndex';
import lowerCase from 'lodash/lowerCase';
import { generateUUID } from 'util/genrateUuid';
import T from 'i18n-react';

import styles from './Tags.module.scss';

const Tags = (props) => {
  const { data = [], suggestions: list = [], onAdd, onDelete, allowNew = false, ...rest } = props;

  const [tags, setTags] = useState(data);
  const [suggestions, setSuggestions] = useState(list);

  const reactTags = useRef();

  // remove tag suggestion if already existed in user tags
  useEffect(() => {
    if (tags.length) {
      const res = [...suggestions];
      // eslint-disable-next-line no-restricted-syntax
      for (const { name } of tags) {
        if (findIndex(res, { name }) > 0) {
          remove(res, ({ name: nameSuggestion }) => lowerCase(nameSuggestion) === lowerCase(name));
        } else {
          // case add new free tag (allowNew)
          res.push({ id: generateUUID(), name });
        }
      }

      setSuggestions(res);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);

  const handleDeleteTag = useCallback(
    (tagIndex) => {
      setTags(tags.filter((_, i) => i !== tagIndex));
      // setSuggestions([...suggestions, tags[tagIndex]]);

      if (onDelete) {
        onDelete(tags[tagIndex]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tags]
  );

  const handleAddTag = useCallback(
    (newTag) => {
      if (tags.filter((tag) => lowerCase(tag.name) === lowerCase(newTag.name)).length) return;

      setTags([...tags, newTag]);
      // setSuggestions(suggestions.filter(({ name }) => name !== get(newTag, 'name')));

      if (onAdd) {
        onAdd(newTag);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [tags]
  );

  return (
    <div className={styles.wrapper}>
      <ReactTags
        ref={reactTags}
        tags={tags}
        suggestions={suggestions}
        onDelete={handleDeleteTag}
        onAddition={handleAddTag}
        minQueryLength={2}
        maxSuggestionsLength={6}
        allowNew={allowNew}
        allowBackspace={false}
        placeholderText={T.translate('tags.placeholder')}
        removeButtonText={T.translate('tags.removeButton')}
        noSuggestionsText={T.translate('tags.noSuggestions')}
        newTagText={T.translate('tags.newTag')}
        {...rest}
      />
    </div>
  );
};

export default Tags;
